// @mui
import { styled } from '@mui/material/styles';
import { Autocomplete, TextField } from '@mui/material';

// ----------------------------------------------------------------------

const InputStyleAutocomplete = styled(TextField, {
  shouldForwardProp: (prop) => prop !== 'stretchStart',
})(({ stretchStart, theme }) => ({
  '& .MuiOutlinedInput-root': {
    transition: theme.transitions.create(['box-shadow', 'width'], {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.shorter,
    }),
    // '&.Mui-focused': {
    //   boxShadow: theme.customShadows.z12,
    // },
    ...(stretchStart && {
      width: stretchStart,
      '&.Mui-focused': {
        boxShadow: theme.customShadows.z12,
        [theme.breakpoints.up('sm')]: {
          width: stretchStart + 60,
        },
      },
    }),
   padding:'2px 2px',
    height:38,
  },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderRadius:3,
    borderColor: `${theme.palette.grey[600]} !important`,
  },
}));

export default InputStyleAutocomplete;
